<div class="">
  <div class="card-body row">
    <ng-container [formGroup]="form">
      <div class="col-4">
        <span>{{ question.text }}</span>
      </div>
      <div class="col-8">
        <div style="width: 100%; height: 51.02px; flex-direction: column; justify-content: center; align-items: flex-start; display: inline-flex">
          <div
            style="align-self: stretch; height: 28px; padding: 4px; background: #FDFDFD; 
                   box-shadow: 0px 0px 16px #F1F1F1; border-radius: 100px; 
                   justify-content: flex-start; align-items: center; display: flex; width: 100%;">

            @for (value of scaleValues; track value; let last = $last) {
              <div
                style="display: flex; justify-content: center; align-items: center; flex: 1;">
                <div style="display: flex; flex-direction: column; align-items: center; width: 100%; cursor: pointer"
                  [class.selected]="value === form.controls[question.uniqueId].value"
                  (click)="setScaleValue(value)">
                  <div
                  style="width: 40px; height: 40px; border-radius: 50%; display: flex; justify-content: center; 
                         align-items: center; background-color: #FDFDFD;"
                    [ngStyle]="{'background': value === form.controls[question.uniqueId].value ? 'transparent' : 'transparent'}">
                    <span
                      [ngStyle]="{'color': value === form.controls[question.uniqueId].value ? 'white' : '#121212'}"
                      style="font-size: 14px; font-family: sans-serif; line-height: 19.60px; text-align: center;">
                      {{ value }}
                    </span>
                  </div>
                </div>
                @if (!last) {
                  <div data-svg-wrapper style="display: flex; align-items: center;">
                    <svg width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.777771 0.015625V11.0156" stroke="#E1E1E1"/>
                    </svg>
                  </div>
                }
              </div>
            }
          </div>

          <div style="align-self: stretch; justify-content: space-between; align-items: center; display: inline-flex; margin-top: 1%;">
            <div class="scale">
              {{ question.scale.min.text }}
            </div>
            @if (question.scale.center) {
              <div class="scale" style="text-align: center">
                {{ question.scale.center.text }}
              </div>
            }
            <div style="text-align: right;" class="scale">
              {{ question.scale.max.text }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>